/**
 * Il punto di estensione sulla visibilità dei task (FILO-41), nei mock.
 *
 * Nel backend un plugin restringe i task che un utente vede con un `TaskVisibilityContributor` (F2:
 * ognuno vede i suoi). I mock del core vengono prima di quelli dei plugin (`mockWorker.ts`), quindi un
 * plugin non può sostituire gli handler dei task: registra qui la sua regola, e gli handler la
 * applicano all'elenco e, con un 404, alle operazioni sul singolo task. Senza regole i mock si
 * comportano come prima.
 */
import type { Task } from '../../entities/task/taskTypes';

export type MockTaskVisibilityRule = (task: Task, user: { userId: number; administrator: boolean }) => boolean;

const rules: MockTaskVisibilityRule[] = [];

export function registerMockTaskVisibility(rule: MockTaskVisibilityRule): void {
  rules.push(rule);
}

/** Vero se ogni regola registrata lascia vedere il task all'utente. */
export const mockTaskVisible = (task: Task, user: { userId: number; administrator: boolean }): boolean =>
  rules.every((rule) => rule(task, user));
